import { Order, OrderEvent } from 'store/orders/orders.types'

export type DropAddressFormData = {
  addressLine1: string
  addressLine2?: string
  city: string
  province: string
  postalCode: string
}

export const buildDropAddress = (data: DropAddressFormData): string =>
  `${data.addressLine1}${data.addressLine2 ? ' ' + data.addressLine2 : ''} ${data.city}, ${data.province}, ${data.postalCode}`

export const createDropTrailerOrderEvent = (
  address: string
): Omit<OrderEvent, 'orderEventId'> => ({
  address,
  endTime: '',
  eventType: 'DROP_TRAILER',
  name: '',
  startTime: '',
  status: 'ASSIGNED',
  hazmat: '',
  loadCount: 0,
  loadType: 'FTL',
  notes: '',
  pickupNumber: '',
  temperatureUnit: 'C',
  temperatureValue: 0,
  weightUnit: '',
  weightValue: 0,
})

export const findNewDropTrailerEvent = (
  previousEvents: OrderEvent[],
  updatedEvents: OrderEvent[],
  address: string
): OrderEvent | undefined => {
  const previousIds = new Set(
    previousEvents
      .map((event) => event.orderEventId)
      .filter((id): id is number => id != null)
  )

  return updatedEvents.find(
    (event) =>
      event.eventType === 'DROP_TRAILER' &&
      event.address === address &&
      event.orderEventId != null &&
      !previousIds.has(event.orderEventId)
  )
}

export const modifyOrderForDeliveryToDrop = (orders: Order[]): Order[] => {
  return orders.map((order) => ({
    ...order,
    orderEvents: order?.orderEvents
      .filter((orderEvent) => orderEvent.eventType === 'DELIVERY')
      .map((orderEvent) => ({
        ...orderEvent,
        eventType: 'PICKUP',
      })),
  }))
}
